import React from 'react';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';

function AuthStatusScreen({
  title = 'Authentifizierung wird verarbeitet',
  subtitle = 'Bitte einen Moment warten.',
}) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        background: 'var(--app-page-background)',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 420,
          p: { xs: 3, sm: 4 },
          borderRadius: 4,
          textAlign: 'center',
          border: '1px solid rgba(122,154,1,0.18)',
          boxShadow: '0 18px 50px rgba(32, 43, 10, 0.10)',
          backgroundColor: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Box
          component="img"
          src="/katho_logo.png"
          alt="Katho Logo"
          sx={{ height: 52, mb: 3 }}
        />

        <Box
          sx={{
            width: 72,
            height: 72,
            mx: 'auto',
            mb: 2.5,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            background:
              'linear-gradient(135deg, rgba(122,154,1,0.14), rgba(138,174,2,0.22))',
          }}
        >
          <CircularProgress
            size={34}
            thickness={4.4}
            sx={{ color: '#7A9A01' }}
          />
        </Box>

        <Typography variant="h5" sx={{ mb: 1, color: '#1f2a08' }}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      </Paper>
    </Box>
  );
}

export default AuthStatusScreen;
